import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import iconUbicacion from '../img/iconoUbicacion.png';
import './mapUsert.css'
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import WhatsAppButton from '../Components/whatsappbutton';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { db } from '../Firebase/Firebase'; // Importa tu configuración de Firebase
import { getDocs, collection, addDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";

// Importa la imagen del icono que quieres usar para la ubicación
import iconoUbicacion from '../img/ubicacionMap.png'; // Reemplaza con la ruta de tu icono

// Icono para la ubicación del clic
import iconoClic from '../img/ubicacionMap.png'; // Reemplaza con la ruta de tu icono de clic

// Crear un icono personalizado para la ubicación actual
const iconoUbicacionPersonalizado = new L.Icon({
    iconUrl: iconoUbicacion,
    iconSize: [45, 45], // Tamaño del icono
    iconAnchor: [16, 32], // Punto de anclaje del icono en las coordenadas
});

// Crear un icono personalizado para el clic
const iconoClicPersonalizado = new L.Icon({
    iconUrl: iconoClic,
    iconSize: [32, 32], // Tamaño del icono
    iconAnchor: [16, 32], // Punto de anclaje del icono
});

const modalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo oscuro y transparente
        zIndex: 1000, // Capa superior del overlay
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1001, // Asegura que el modal esté encima del overlay
        padding: '20px',
        borderRadius: '10px',
        maxWidth: '500px',
        width: '90%',
    },
};
const MapUsert = () => {

    const navigate = useNavigate();
    // Función para generar un ID único para invitados
    const generateGuestId = () => {
        return `Invitado_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    };

    // Función para obtener o generar un ID único para invitados
    const getGuestId = () => {
        const guestIdKey = "guestId";
        let guestId = sessionStorage.getItem(guestIdKey);
        if (!guestId) {
            guestId = generateGuestId();
            sessionStorage.setItem(guestIdKey, guestId);
        }
        return guestId;
    };

    const registrarClic = async (seccion, datosClic) => {
        const auth = getAuth();
        const user = auth.currentUser;
    
        // Obtener datos del usuario
        const nombreUsuario = user?.displayName || "Invitado";
        const [nombre, apellido = ""] = nombreUsuario.split(" ");
        const email = user?.email || "Sin email";
        const userId = user?.uid || getGuestId(); // Si no está autenticado, generar un ID único para el invitado
    
        // Referencia al documento del usuario en Firestore
        const userDocRef = doc(db, "Interacciones", userId);
    
        try {
            // Verificar si el documento del usuario ya existe
            const userDoc = await getDoc(userDocRef);
    
            if (!userDoc.exists()) {
                // Si no existe, crear un documento para el usuario
                await setDoc(userDocRef, {
                    nombre,
                    apellido,
                    email,
                    clics: {}, // Inicializar el mapa de clics
                });
            }
    
            // Obtener los datos existentes del usuario
            const userData = userDoc.exists() ? userDoc.data() : {};
            const clicsExistentes = userData.clics?.[seccion] || [];
    
            // Verificar si ya existe un clic para el mismo dato
            const clicExistente = clicsExistentes.find(clic => clic.idLugar === datosClic.idLugar);
    
            // Agregar la fecha y hora al clic
            const fechaHora = new Date(); // Fecha y hora actuales
    
            if (clicExistente) {
                // Incrementar el contador del clic existente
                clicExistente.contador = (clicExistente.contador || 1) + 1;
                clicExistente.fechaHora = fechaHora; // Actualizar la fecha y hora
    
                // Actualizar la sección en Firestore
                await updateDoc(userDocRef, {
                    [`clics.${seccion}`]: [
                        ...clicsExistentes.filter(clic => clic.idLugar !== datosClic.idLugar), // Mantener otros clics
                        clicExistente, // Reemplazar el actualizado
                    ],
                });
            } else {
                // Agregar un nuevo clic con contador inicializado y fechaHora
                datosClic.contador = 1;
                datosClic.fechaHora = fechaHora; // Incluir la fecha y hora del clic
    
                await updateDoc(userDocRef, {
                    [`clics.${seccion}`]: arrayUnion(datosClic),
                });
            }
    
            console.log(`Clic registrado en la sección "${seccion}" para el usuario:`, datosClic);
        } catch (error) {
            console.error("Error al registrar clic:", error);
        }
    };
    


    // Función para obtener los detalles del lugar
    const obtenerDetallesLugar = async (idLugar) => {
        const lugarRef = doc(db, "lugar", idLugar); // Referencia al documento en la colección "lugar"
        const lugarDoc = await getDoc(lugarRef);

        if (lugarDoc.exists()) {
            // Obtener los detalles del lugar
            const lugarData = lugarDoc.data();
            return {
                nombreLugar: lugarData.NombreLugar,
                sector: lugarData.Sector,
                direccion: lugarData.Direccion,
            };
        } else {
            console.error('No se encontró el lugar con ID:', idLugar);
            return null;
        }
    };

    // Función para manejar el clic en la sección "Lugares"
    const navigateToLocation = async (idLugar) => {
        try {
            const lugarDetalles = await obtenerDetallesLugar(idLugar);

            if (lugarDetalles) {
                const datosClic = { idLugar, lugarDetalles }; // Incluir los detalles del lugar en los datos del clic
                await registrarClic("Lugares", datosClic); // Registrar en la colección "Lugares"
                sessionStorage.setItem('selectedLocation', JSON.stringify({ id: idLugar }));
                //let route;
               
                //route='lugar/'+idLugar;

                // Navegar a la ruta correspondiente
                navigate('/lugar/'+idLugar);
            }
        } catch (error) {
            console.error('Error al redirigir o registrar clic:', error);
        }
    };

    const [userLocation, setUserLocation] = useState(null);
    const mapRef = useRef();
    const [clickPosition, setClickPosition] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [ciudadLugar, setCiudadLugar] = useState('');
    const [nombreLugar, setNombreLugar] = useState('');
    const [idLugar, setIdLugar] = useState('');
    const [selectedLocation, setSelectedLocation] = useState(null); // Guardar la ubicación seleccionada
    const [modalIsOpenUpdate, setModalIsOpenUpdate] = useState(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false); // Modal de verificación de eliminación
    const closeDeleteModal = () => setDeleteModalIsOpen(false);
    const [map, setMap] = useState(null);


    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const location = [position.coords.latitude, position.coords.longitude];
                setUserLocation(location);
                if (mapRef.current) {
                    mapRef.current.setView(location, 16);
                }
            },
            (error) => {
                console.error("Error obteniendo la ubicación del usuario:", error);
            }
        );
    }, []);

    ;
    const [sectors, setSectors] = useState([]);

    // Función para obtener ubicaciones y sectores
    const fetchLocations = async () => {
        try {
            const snapshot = await getDocs(collection(db, "lugar"));
            const locationsArray = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            setRegisteredLocations(locationsArray);
            setFilteredLocations(locationsArray);

            // Extraer sectores únicos
            const uniqueSectors = [...new Set(locationsArray.map(location => location.Sector))];
            setSectors(uniqueSectors);
        } catch (error) {
            console.error("Error al recuperar ubicaciones:", error);
        }
    };



    // Manejar búsqueda por NombreLugar
    const handleNombreLugarChange = async (e) => {
        setIsSearching(true); // Indicar que está buscando
        const nombreLugar = e.target.value.toLowerCase();
        setSelectedNombreLugar(nombreLugar);

        if (nombreLugar === "") {
            setFilteredLocations(registeredLocations);
        } else {
            const filtered = registeredLocations.filter(location =>
                location.NombreLugar?.toLowerCase().includes(nombreLugar)
            );
            setFilteredLocations(filtered);
        }

        setTimeout(() => setIsSearching(false), 3000); // Simula una búsqueda breve
    };

    useEffect(() => {
        fetchLocations();
    }, []);
    // Función para abrir el modal con los datos del lugar seleccionado
    const handleMarkerClick = (location) => {
        setSelectedLocation({
            id: location.IdLugar,
            ciudadLugar: location.CiudadLugar,
            nombreLugar: location.NombreLugar,
            direccion: location.Direccion,
            Latitud: location.Latitud,
            Longitud: location.Longitud,
            urlImagen: location.ImagenUrl
        });
        setModalIsOpenUpdate(true);
        // Desplazar al contenedor de detalles
        const detalleContenedor = document.getElementById("detalleContenedor");
        if (detalleContenedor) {
            detalleContenedor.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    const [selectedNombreLugar, setSelectedNombreLugar] = useState('');

    const CenterMapOnLocations = ({ locations }) => {
        const map = useMap();

        useEffect(() => {
            if (locations.length > 0) {
                const lat = parseFloat(locations[0].Latitud) || 0;
                const lng = parseFloat(locations[0].Longitud) || 0;

                if (!isNaN(lat) && !isNaN(lng)) {
                    const zoom = locations.length === 1 ? 16 : 13;
                    map.flyTo([lat, lng], zoom); // Ajustar la vista del mapa
                } else {
                    console.error("Error: Coordenadas no válidas", { lat, lng });
                }
            }
        }, [locations, map]);

        return null;
    };

    const [isSearching, setIsSearching] = useState(false);
    const sectoresPorCiudad = {
        "Quito": [
            "Centro Histórico",
            "La Mariscal",
            "La Carolina",
            "Cumbayá",
            "El Condado",
            "Carapungo",
            "Tumbaco",
            "El Inca",
            "Calderón",
            "Carcelén",
            "Ponceano",
            "Cotocollao",
            "La Floresta",
            "González Suárez",
            "Quito Tenis",
            "La Pradera",
            "Bellavista",
            "El Batán",
            "Chillogallo",
            "La Magdalena",
            "Quitumbe",
            "El Recreo",
            "Solanda",
            "La Ecuatoriana",
            "San Roque",
            "San Juan",
            "El Tejar",
            "San Juan de Cumbayá",
            "Nayón",
            "Lumbisí",
            "San Rafael",
            "Conocoto",
            "La Armenia",
            "Fajardo",
            "Tingo María",
            "La Loma"
        ],
        "Guayaquil": ["Samborondón", "Urdesa", "Ceibos", "Centro", "Las Peñas", "Mapasingue", "Durán", "Alborada"],
        "Cuenca": ["El Vergel", "El Centro", "Totoracocha", "Baños", "Monay", "Yanuncay", "San Joaquín", "Misicata"],
        "Ambato": ["Centro", "Atocha", "Ficoa", "Miraflores", "Ingahurco", "Huachi Chico", "La Merced"],
        "Manta": ["Tarqui", "El Murciélago", "Los Esteros", "La Pradera", "San Mateo", "Cuba Libre", "Barbasquillo"],
        "Portoviejo": ["El Florón", "Andrés de Vera", "San Alejo", "Ciudadela Universitaria", "24 de Mayo", "Francisco Pacheco"],
        "Loja": ["San Sebastián", "El Valle", "Ciudad Victoria", "Punzara", "Carigán", "Jipiro", "La Argelia"],
        "Esmeraldas": ["Centro", "5 de Agosto", "San Rafael", "La Propicia", "Las Palmas", "La Concordia", "Tachina"],
        "Machala": ["9 de Mayo", "El Cambio", "Puerto Bolívar", "Primera Zona", "La Ferroviaria", "La Florida"],
        "Riobamba": ["Loma de Quito", "Santa Rosa", "Capulispamba", "Bellavista", "La Politécnica", "Parque Industrial"],
        "Ibarra": ["Centro Histórico", "El Retorno", "Azaya", "Caranqui", "Yacucalle", "La Esperanza"],
        "Santo Domingo": ["Abelardo Montalvo", "La Concordia", "Plan de Vivienda", "Tsáchilas", "Río Verde", "Los Rosales"],
        "Babahoyo": ["El Mamey", "La Ventura", "La Chorrera", "Caracol", "Camilo Ponce", "Ciudadela Universitaria"],
        "Quevedo": ["San Camilo", "7 de Octubre", "24 de Mayo", "El Guayacán", "Los Guayacanes", "Los Ángeles"],
        "Tulcán": ["El Rosario", "La Floresta", "Santa Clara", "San Gabriel", "Ciudadela del Norte"],
        "Latacunga": ["San Felipe", "El Salto", "Ignacio Flores", "La Laguna", "Centro", "La Estación"],
        "Otavalo": ["Peguche", "Ilumán", "Cotama", "San Pablo", "Monserrath", "El Jordán"],
        "Milagro": ["El Bosque", "12 de Octubre", "Los Vergeles", "Las Piñas", "Río Bonito", "San Francisco"],
        "Durán": ["El Recreo", "Divino Niño", "Panorama", "La Ferroviaria", "Orquídeas", "Venecia"],
        "Tena": ["San Juan", "San José", "Las Palmas", "Misahuallí", "Puerto Napo", "Unión Base"],
        "Nueva Loja": ["La Primavera", "La Mariscal", "El Dorado", "12 de Octubre", "San Sebastián", "Las Palmas"],
        "Zamora": ["El Centro", "Zumbi", "Yantzaza", "Cumbaratza", "San Francisco", "La Pituca"],
        "Santa Elena": ["La Libertad", "Ballenita", "Salinas", "Punta Carnero", "Anconcito", "Ayangue"],
        "Playas": ["Villamil", "San Antonio", "El Arenal", "Data de Posorja", "Posorja", "Progreso"],
        "Puyo": ["El Recreo", "Pomona", "Fatima", "Mera", "Shell", "Las Américas", "Tena"],
        "Ciudad desconocida": [], // Opcional: Para manejar casos donde no se detecte la ciudad
    };
    // Estado para ciudades, sectores y registros
    const [ciudades, setCiudades] = useState(Object.keys(sectoresPorCiudad));
    const [sectores, setSectores] = useState([]);
    const [selectedCiudad, setSelectedCiudad] = useState("");
    const [selectedSector, setSelectedSector] = useState("");
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [registeredCities, setRegisteredCities] = useState(new Set());
    const [registeredSectors, setRegisteredSectors] = useState(new Set());
    const [registeredLocations, setRegisteredLocations] = useState([]);

    const handleCiudadChange = async (e) => {
        setIsSearching(true); // Indicar que está buscando
        const ciudad = e.target.value;
        setSelectedCiudad(ciudad);
        setSelectedSector(""); // Resetea el sector al cambiar la ciudad

        if (ciudad === "Todas las ciudades") {
            setFilteredLocations(registeredLocations);
            setSectores([]);
        } else {
            setSectores(sectoresPorCiudad[ciudad] || []);
            const filtered = registeredLocations.filter(location => location.CiudadLugar === ciudad);
            setFilteredLocations(filtered);
        }
        setTimeout(() => setIsSearching(false), 3000); // Simula una búsqueda breve
    };

    const handleSectorChange = async (e) => {
        const sector = e.target.value;
        setSelectedSector(sector);
        setIsSearching(true); // Indicar que está buscando

        if (sector === "Todos los sectores") {
            const filtered = registeredLocations.filter(location => location.CiudadLugar === selectedCiudad);
            setFilteredLocations(filtered);
        } else {
            const filtered = registeredLocations.filter(location =>
                location.CiudadLugar === selectedCiudad && location.Sector === sector
            );
            setFilteredLocations(filtered);
        }

        // Registrar la búsqueda en Firebase
        await registrarBusqueda({
            ciudad: selectedCiudad || null,
            sector: sector || null,
        });

        setTimeout(() => setIsSearching(false), 3000); // Simula una búsqueda breve
    };

    // Fetch inicial de ubicaciones
    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const snapshot = await getDocs(collection(db, "lugar"));
                const locationsArray = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setRegisteredLocations(locationsArray);

                // Identificar ciudades y sectores registrados
                const citiesSet = new Set(locationsArray.map(location => location.CiudadLugar));
                const sectorsSet = new Set(locationsArray.map(location => location.Sector));
                setRegisteredCities(citiesSet);
                setRegisteredSectors(sectorsSet);

                // Filtrar inicialmente
                setFilteredLocations(locationsArray);
            } catch (error) {
                console.error("Error al recuperar ubicaciones:", error);
            }
        };

        fetchLocations();
    }, [db]);

    const registrarBusqueda = async (busqueda) => {
        const auth = getAuth();
        const user = auth.currentUser;

        // Obtener el nombre y apellido del usuario
        const nombreUsuario = user?.displayName || "Invitado";
        const [nombre, apellido = ""] = nombreUsuario.split(" ");

        const email = user?.email || "Sin email";

        // Construir el registro de búsqueda
        const searchRecord = {
            ...busqueda,
            usuario: {
                nombre: nombre || "Invitado",
                apellido: apellido || "No especificado",
                email,
            },
            timestamp: new Date().toISOString(),
        };

        try {
            await addDoc(collection(db, "SectoresBuscados"), searchRecord);
            console.log("Búsqueda registrada en Firebase:", searchRecord);
        } catch (error) {
            console.error("Error al registrar la búsqueda:", error);
        }
    };

    return (
        <div>
            <Navbar />
            <WhatsAppButton />

            <div className="input-group-mapUsert">
                {/* Filtro de búsqueda */}
                <input
                    className="filtroMapUsert"
                    style={{
                        padding: '15px',
                        width: '18%',
                        border: 'none',
                        margin: '0',
                        padding: '10px',
                        outline: 'none',
                        borderRadius: '5px',
                        boxShadow: 'none',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                    }}
                    type="text"
                    placeholder="Nombre"
                    value={selectedNombreLugar}
                    onChange={handleNombreLugarChange}
                />

                <select
                    className="rounded-select-mapUsert"
                    value={selectedCiudad}
                    onChange={handleCiudadChange}
                >
                    <option value="Todas las ciudades">Ciudades</option>
                    {ciudades.map((ciudad, index) => (
                        <option
                            key={index}
                            value={ciudad}
                            style={{
                                fontWeight: registeredCities.has(ciudad) ? "bold" : "normal",
                                color: registeredCities.has(ciudad) ? "green" : "black"
                            }}
                        >
                            {registeredCities.has(ciudad) ? `⭐ ${ciudad}` : ciudad}
                        </option>
                    ))}
                </select>

                {/* Select de sectores dinámico */}
                <select
                    className="rounded-select-mapUsert"
                    value={selectedSector}
                    onChange={handleSectorChange}
                    disabled={!selectedCiudad}
                >
                    <option value="Todos los sectores">Sectores</option>
                    {sectores.map((sector, index) => (
                        <option
                            key={index}
                            value={sector}
                            style={{
                                fontWeight: registeredSectors.has(sector) ? "bold" : "normal",
                                color: registeredSectors.has(sector) ? "blue" : "black"
                            }}
                        >
                            {registeredSectors.has(sector) ? `⭐ ${sector}` : sector}
                        </option>
                    ))}
                </select>

                <button
                    className="rounded-button"
                    style={{
                        backgroundColor: isSearching ? "orange" : "",
                        color: isSearching ? "white" : "",
                    }}
                >
                    {isSearching ? "Buscando..." : "Buscar"}
                </button>
            </div>

            <div class="contenedor-principal-mapUsert">
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />

                <div class="columna-1-mapUsert">

                    <div>
                        {filteredLocations.length > 0 ? (
                            <MapContainer
                                center={[
                                    parseFloat(filteredLocations[0]?.Latitud) || 0,
                                    parseFloat(filteredLocations[0]?.Longitud) || 0,
                                ]}
                                zoom={13}
                                zoomAnimation={true}
                                zoomAnimationThreshold={4}
                                className="mapaUsert"
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />

                                {/* Centrar mapa dinámicamente en base a las ubicaciones */}
                                <CenterMapOnLocations locations={filteredLocations} />

                                {/* Marcadores para ubicaciones registradas */}
                                {filteredLocations.map(location => {
                                    const lat = parseFloat(location.Latitud);
                                    const lng = parseFloat(location.Longitud);

                                    if (isNaN(lat) || isNaN(lng)) {
                                        console.error(`Error: Latitud o Longitud no válidas para el ID: ${location.id}`, { lat, lng });
                                        return null;
                                    }

                                    return (
                                        <Marker
                                            key={location.id}
                                            position={[lat, lng]}
                                            icon={iconoUbicacionPersonalizado}
                                            eventHandlers={{
                                                click: () => handleMarkerClick(location),
                                            }}
                                        />
                                    );
                                })}
                            </MapContainer>
                        ) : (
                            <>
                                <p style={{ textAlign: "center", color: "orange", marginTop: "0" }}>
                                    No hay coincidencias.
                                </p>
                                <MapContainer
                                    center={[-0.1807, -78.4678]} // Coordenadas de Quito
                                    zoom={13} // Nivel de zoom para Quito
                                    zoomAnimation={true}
                                    zoomAnimationThreshold={4}
                                    className="mapaUsert"
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    />
                                </MapContainer>
                            </>
                        )}
                    </div>
                    <div className="informacion-seleccionada" id="detalleContenedor">
                        {selectedLocation ? (
                            <div className="detalle-lugar" style={{ display: "flex", gap: "20px" }}>
                                {/* Primera columna: Imagen */}
                                <div style={{ flex: "1" }}>
                                    <img
                                        src={selectedLocation.urlImagen || 'ruta-de-imagen-predeterminada.jpg'}
                                        alt={selectedLocation.nombreLugar || 'Imagen del lugar'}
                                        className="detalle-imagen"
                                        style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                                    />
                                </div>

                                {/* Segunda columna: Detalles */}
                                <div style={{ flex: "1" }}>
                                    <form>
                                        <div>
                                            <label className="detalle-label" style={{ display: "block", fontWeight: "bold", fontSize: "1.2rem" }}>
                                                {selectedLocation.nombreLugar || 'N/A'}
                                            </label>
                                            <p>{selectedLocation.direccion || 'N/A'}</p>
                                            <label className="detalle-label" style={{ display: "block", marginTop: "10px" }}>
                                                {selectedLocation.direccion || 'N/A'}
                                            </label>
                                        </div>
                                        <button
                                            type="button"
                                            className="boton-detalle"
                                            onClick={() => navigateToLocation(selectedLocation.id)}
                                            style={{ marginTop: "20px", padding: "10px 20px", fontSize: "1rem" }}
                                        >
                                            Comenzar Tour
                                        </button>
                                    </form>
                                </div>
                            </div>
                        ) : (
                            <p style={{ textAlign: "center", color: "gray", marginTop: "10px" }}>
                                Selecciona un lugar en el mapa para ver los detalles.
                            </p>
                        )}
                    </div>
                </div>
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />

            </div>

        </div>

    );

};


export default MapUsert;
